import React from 'react'

import { sanitizeAndProcessHtml } from '@/_lib/dom-purify.utils'

export interface QuoteData {
	text: string
	caption: string
	alignment?: 'left' | 'center' | 'right'
}

export interface BEditorJsQuoteProps {
	data: QuoteData
}

export const BEditorJsQuote: React.FC<BEditorJsQuoteProps> = ({ data }) => {
	const { text, caption, alignment = 'left' } = data

	if (!text && !caption) {
		return null
	}

	const containerClasses = {
		left: 'text-left',
		center: 'text-center',
		right: 'text-right'
	}

	return (
		<div className='editorjs-renderer_block'>
			<blockquote
				className={`${
					containerClasses[alignment || 'center']
				} px-8 py-12 my-6 bg-[#93278F] rounded-lg relative overflow-hidden`}
			>
				<div className='absolute bottom-0 right-0 z-0'>
					<img
						src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/legacy/medante-graphics.svg`}
						alt='Ilustračná fotografia'
						className='max-w-[200px] max-h-[100px] opacity-20'
						loading='lazy'
					/>
				</div>
				<div className='relative z-10'>
					{text && (
						<p
							className='!text-lg !font-light !text-[#F3EFE4] !mb-3 !w-full !italic !focus:outline-none'
							suppressHydrationWarning
							dangerouslySetInnerHTML={{ __html: sanitizeAndProcessHtml(text) }}
						/>
					)}
					{caption && (
						<footer
							className='text-base font-medium text-[#F3EFE4] focus:outline-none'
							suppressHydrationWarning
							dangerouslySetInnerHTML={{ __html: sanitizeAndProcessHtml(caption) }}
						/>
					)}
				</div>
			</blockquote>
		</div>
	)
}

export default BEditorJsQuote
